
export const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
export const week = { 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 }
export const weekMap = ['日', '一', '二', '三', '四', '五', '六']

// const REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?/

/**
 * @description 构建指定长度数组
 * @param {number} length
 * @returns {undefined[]}
 */
export const makeArr = (length) => Array.apply([], { length })

/**
 * @description 获取当前月份天数
 * @param {number | string} y
 * @param {number | string} m
 * @returns {number}
 */
export const getMonthEndDay = (y, m) => 32 - new Date(y, m - 1, 32).getDate()

export const toDate = (date) => {
  if (!date) return new Date()
  if (date instanceof Date) return date

  return new Date(date)
}
/**
 * @description 便于时间取值
 * @param  {...any} args
 */
export const getFullDate = (date) => {
  const _d = toDate(date).toString().split(' ')
  const _m = _d[4].match(/(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?/) || []

  return {
    year: +_d[3],
    month: +month.indexOf(_d[1]) + 1,
    day: +_d[2],
    hour: +_m[1],
    minute: +_m[2],
    second: +_m[3],
    week: +week[_d[0]],
    weekName: weekMap[+week[_d[0]]]
  }
}

export const getWeek = (date) => {
  const _d = toDate(date).toString().split(' ')
  var weekName = weekMap[+week[_d[0]]]
  return "周"+weekName
}
export const getDay = (date) => {
  const _d = toDate(date).toString().split(' ')
  return +[_d[2]]
}
export function getToday() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

export function isToday(date) {
  if (!(date instanceof Date)) {
    date = new Date(date);
  };

  date.setHours(0, 0, 0, 0);

  return getToday().getTime() === date.getTime()
}

export function isTomorrow(date) {
  if (!(date instanceof Date)) {
    date = new Date(date);
  };
  date.setDate(date.getDate() - 1)
  date.setHours(0, 0, 0, 0);

  return getToday().getTime() === date.getTime()
}

/**
 *
 * @description 比较俩个时间
 * @export
 * @param {*} date1
 * @param {*} date2
 * @return {*}
 *  0 - 相等
 *  1 - date1 > date2
 *  -1 date1 < date2
 */
export function compare(date1, date2) {
  if (!(date1 instanceof Date)) {
    date1 = new Date(date1);
  }

  if (!(date2 instanceof Date)) {
    date2 = new Date(date2);
  }

  const year1 = date1.getFullYear();
  const year2 = date2.getFullYear();
  const month1 = date1.getMonth();
  const month2 = date2.getMonth();
  const day1 = date1.getDate();
  const day2 = date2.getDate();

  if(year1 === year2) {
    return month1 === month2
    ? day1 === day2 ? 0 : day1 > day2 ? 1: -1
    : month1 > month2 ? 1 : -1;
  }

  return year1 > year2 ? 1 : -1
}

export function compareMonth(date1, date2) {
  if (!(date1 instanceof Date)) {
    date1 = new Date(date1);
  }

  if (!(date2 instanceof Date)) {
    date2 = new Date(date2);
  }

  const year1 = date1.getFullYear();
  const year2 = date2.getFullYear();
  const month1 = date1.getMonth();
  const month2 = date2.getMonth();
 

  if(year1 === year2) {
    return month1 === month2
    ? 0
    : month1 > month2 ? 1 : -1;
  }

  return year1 > year2 ? 1 : -1
}

export function compareDay(day1, day2) {
  if (!(day1 instanceof Date)) {
    day1 = new Date(day1);
  }

  if (!(day2 instanceof Date)) {
    day2 = new Date(day2);
  }

  const month = compareMonth(day1, day2);

  if (month === 0) {
    const date1 = day1.getDate();
    const date2 = day2.getDate();

    return date1 === date2 ? 0 : date1 > date2 ? 1 : -1;
  }

  return month;
}

export function calcDateNum(date1, date2) {
  const day1 = new Date(date1).getTime();
  const day2 = new Date(date2).getTime();
  return (day2 - day1) / (1000 * 60 * 60 * 24) + 1;
}

export function getDayByOffset(date, offset) {
  date = date instanceof Date ? date : parseDate(date);
  date.setDate(date.getDate() + offset);

  return date;
}

export function getPrevDay(date) {
  return getDayByOffset(date, -1);
}

export function getNextDay(date) {
  return getDayByOffset(date, 1);
}

/**
 * @description: 时间格式化方法
 * @param {*} date 需要格式化的时间，默认为当前时间
 * @param {*} fmt YYYY-MM-dd hh:mm:ss
 * @return {string} 格式化后的字符串时间
 */
export const formatDate = (date = new Date(), fmt = 'YYYY-MM-dd') => {
  if (typeof date == 'string' || typeof date == 'number') {
    if (typeof date === 'string') {
      // ios 中 '2018-04-27 11:11' 格式的字符串不能 new Date(), 需要将 '-' 替换为 '/'
      date = date.replace(/-/g, '/')
    }
    date = new Date(date)
  }
  if (date == 'Invalid Date') {
    return ''
  }
  const o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  }
  if (/(y+)/i.test(fmt)) {
    fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
  }
  return fmt
}

/**
 * @description: 转Date对象
 * @param {*} date 字符串或数字
 * @return {Date} Date实例 
 */
export const parseDate = (date)=>{
  if (typeof date == 'string' || typeof date == 'number') {
    if (typeof date === 'string') {
      // ios 中 '2018-04-27 11:11' 格式的字符串不能 new Date(), 需要将 '-' 替换为 '/'
      date = date.replace(/-/g, '/')
    }
    date = new Date(date)
  }
  if (date === 'Invalid Date') {
    throw new Error('Invalid Date 日期格式不正确')
  }
  return date
}
